import { IContainer, injectContainer } from '../../interface/container';

export type ISettingsKey = number | string | Date;

export interface ISettingsStorage {
    get: (key: ISettingsKey) => Promise<unknown>;
    set: (key: ISettingsKey, val: unknown) => Promise<void>;
    delete: (key: ISettingsKey) => Promise<void>;
    clear: () => Promise<void>;
    keys: () => Promise<Array<ISettingsKey>>;
}

const TYPES = {
    ISettingsStorage: Symbol.for('ISettingsStorage'),
};

export function injectSettingsStorage(container: IContainer = injectContainer()): ISettingsStorage {
    return container.get<ISettingsStorage>(TYPES.ISettingsStorage);
}

export function bindSettingsStorage(
    val: ISettingsStorage,
    container: IContainer = injectContainer(),
) {
    return container.bind<ISettingsStorage>(TYPES.ISettingsStorage, val);
}

export function unbindSettingsStorage(container: IContainer = injectContainer()) {
    return container.remove(TYPES.ISettingsStorage);
}
